import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseVacation: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.25 3a.75.75 0 01.75-.75c.881 0 1.592.222 2.15.595.554.369.914.856 1.146 1.32.087.174.157.347.214.513.125-.076.26-.152.405-.224.851-.426 2.12-.775 3.42-.125a.75.75 0 11-.67 1.342c-.7-.35-1.431-.2-2.08.125a4.21 4.21 0 00-.244.132 6.08 6.08 0 012.399 3.948.75.75 0 11-1.48.247 4.582 4.582 0 00-1.452-2.693 4.682 4.682 0 00-.749-.556A7.307 7.307 0 0015.787 8.2c-.787 1.05-1.65 2.712-1.969 5.192l-.068-.006c3.423.537 6.244 2.623 6.873 5.46.249 1.12-.714 1.904-1.623 1.904H5c-.909 0-1.872-.784-1.623-1.905C4.11 15.537 7.825 13.25 12 13.25c.108 0 .216.002.324.005.347-2.775 1.32-4.697 2.264-5.955a9.33 9.33 0 01.806-.941 5.947 5.947 0 00-.496-.048c-1.052-.055-2.315.167-3.368 1.22a.75.75 0 11-1.06-1.061c1.447-1.448 3.184-1.726 4.507-1.656.376.02.722.067 1.026.125a2.608 2.608 0 00-.049-.104 1.884 1.884 0 00-.636-.742c-.285-.19-.7-.343-1.318-.343a.75.75 0 01-.75-.75zM8.5 8a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM7 8a2 2 0 11-4 0 2 2 0 014 0zM5 19s1.134-4 7-4 7 4 7 4H5z"
        fill={color}
      />
    </svg>
  );
};
